var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kst-item-status"},[_c('kst-icon',{attrs:{"item-status-mode":"","value":_vm.data[_vm.field]}}),_c('kst-value',{attrs:{"field":_vm.field,"data":_vm.data,"catalog":_vm.catalog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }